const styles = theme => ({
  container: {
  	'& .MuiPaper-root': {
        minWidth: '380px',
    	backgroundColor: theme.palette.primary.main,
    	'& .MuiDialogTitle-root': {
    		'& h2': {
    			color: theme.palette.primary.contrastText,
    			paddingTop: 0
    		}
    	},
    	'& .MuiDialogContent-root': {
    		backgroundColor: theme.palette.primary.contrastText,
    		color: theme.palette.primary.main,
    	},
    	'& .MuiDialogActions-root': {
    		backgroundColor: theme.palette.primary.contrastText,
    	}
    }
  },
  textField: {
    width: '100%',
    backgroundColor: theme.palette.primary.contrastText,
    color: theme.palette.primary.main,
    padding: 0,
    '& .MuiInputBase-multiline': {
        padding: '6px 0 7px 10px',
        border: `solid 1px ${theme.palette.primary.main}`
    }
  },
});

export default styles;
